const recommendationTemplate = `
<!DOCTYPE html>
<html>
  <head> </head>
  <body>
  <h2 class="pdf-table-heading">Recommendations</h2>
    <table id="table-comment">

      <tr>
        <th>
          <h3>Investment Recommendations:</h3>
        </th>
      </tr>
      <tr>
        <th><span class="table-subhead">Classification:</span> <span>{{recomendationData.Investment_Key1.text}}</span> </th>
      </tr>
      <tr>
        <th>Asset Manager Rationale</th>
      </tr>
      <tr>
        <td>
	{{{recomendationData.Investment_Key1.assetManagerRationale}}}
        </td>
      </tr>
      {{#if internationalInd}}
      <tr>
        <th>Portfolio Manager Rationale</th>
      </tr>
      <tr>
        <td>
	{{{recomendationData.Investment_Key1.portfolioManagerRationale}}}
        </td>
      </tr>
      {{/if}}
      <tr>
      <th ><span class="table-subhead">Hold Period:</span> <span>{{recomendationData.Investment_Key2.text}}</span> </th>
      </tr>
      <tr>
        <th>Asset Manager Rationale</th>
      </tr>
      <tr>
        <td>
		{{{recomendationData.Investment_Key2.assetManagerRationale}}}
        </td>
      </tr>
      {{#if internationalInd}}
      <tr>
        <th>Portfolio Manager Rationale</th>
      </tr>
      <tr>
        <td>
		{{{recomendationData.Investment_Key2.portfolioManagerRationale}}}
        </td>
      </tr>
      {{/if}}
      <tr>
      <th ><span class="table-subhead">Actions:</span> <span>{{recomendationData.Investment_Key3.text}}</span> </th>
      </tr>
      <tr>
        <th>Asset Manager Rationale</th>
      </tr>
      <tr>
        <td>
		{{{recomendationData.Investment_Key3.assetManagerRationale}}}
        </td>
      </tr>
      {{#if internationalInd}}
      <tr>
        <th>Portfolio Manager Rationale</th>
      </tr>
      <tr>
        <td>
		{{{recomendationData.Investment_Key3.portfolioManagerRationale}}}
        </td>
      </tr>
      {{/if}}
    </table>
    <br></br>
    {{#if recommendationComment}}
    <table id="comment-table">
    <tbody>
      <tr>
        <th>Mission Statement</th>
      </tr>
      <tr>
        <td>
          {{{recommendationComment.commentText}}}
        </td>
      </tr>
    </tbody>
  </table>
  {{/if}}
    </body>
</html>
       `;

export default recommendationTemplate;
